// Generated from the approved MagicPath revision 440407833339629568. Do not hand-edit; update the source worktree instead.
import { useState } from 'react';
const faqPlate = "/assets/page10-faq.jpg";
const navigation = ['METHOD', 'HOUSE 45', 'INSIGHTS', 'ASSESSMENT'];
const answers = [{
  question: 'PRIVATE?',
  answer: <>Yes. Everything you share is confidential.<br />This is a private space to be honest and move forward.</>
}, {
  question: 'IS THIS THERAPY?',
  answer: <>No. It’s performance coaching. We refer out when someone needs clinical care.</>
}, {
  question: 'DO I HAVE TO CALL MYSELF AN ADDICT?',
  answer: <>No. Wrong question. The only one that counts: who’s got the edge right now, you or them?</>
}, {
  question: 'WHAT IF I SLIP?',
  answer: <>You tell your coach immediately, we contain it, find what failed, and fix it. Hiding it is the only real problem.</>
}];
export const Page10StraightAnswers = () => {
  const [activeNav, setActiveNav] = useState('ASSESSMENT');
  const [open, setOpen] = useState(0);
  return <main className="answers-page">
    <img className="answers-photo" src={faqPlate} alt="Blue dawn over a quiet ocean" />
    <div className="answers-grade" aria-hidden="true" />
    <button className="answers-wordmark" type="button" aria-label="IMTHEHOUSE home">IMTHEHOUSE</button>
    <nav className="answers-navigation" aria-label="Primary navigation">
      {navigation.map((item, index) => <span key={item}><button type="button" className={activeNav === item ? 'active' : ''} onClick={() => setActiveNav(item)} aria-pressed={activeNav === item}>{item}</button>{index < navigation.length - 1 && <i aria-hidden="true">•</i>}</span>)}
    </nav>

    <section className="answers-panel" aria-labelledby="answers-heading">
      <h1 id="answers-heading">STRAIGHT ANSWERS.</h1><span className="answers-rule" aria-hidden="true" />
      <div className="answers-list">
        {answers.map((item, index) => <article key={item.question} className={open === index ? 'open' : ''}>
          <button type="button" onClick={() => setOpen(open === index ? -1 : index)} aria-expanded={open === index}>
            <span>{item.question}</span><i aria-hidden="true">{open === index ? '−' : '+'}</i>
          </button>
          <div className="answer-copy" aria-hidden={open !== index}>{item.answer}</div>
        </article>)}
      </div>
    </section>

    <footer className="answers-footer">
      <div><strong>SCENE 10</strong><span className="answers-progress">{Array.from({
            length: 9
          }).map((_, index) => <i key={index} className={index === 7 ? 'active' : ''} />)}</span><b>11</b></div>
      <button type="button">FULL FAQ <span>→</span></button>
    </footer>
  </main>;
};